import { C } from "../../lib/constants";

export const Btn = ({children, onClick, color=C.accent, outline=false, full=false, small=false}) => (
  <button onClick={onClick} style={{background:outline?"transparent":color,border:`2px solid ${color}`,color:outline?color:"#fff",borderRadius:12,padding:small?"8px 16px":"13px 20px",fontWeight:700,fontSize:small?12:14,cursor:"pointer",width:full?"100%":"auto",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",transition:"all 0.15s"}}>{children}</button>
);
